import clsx from "clsx";
import Header from "components/Headers/Header";
import { ErrorMessage, Formik } from "formik";
import React, { useState } from "react";
import ProtectedRoute from "components/ProtectedRoute";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { updateAuthor } from "utils/endpoint";
import UseFullPageLoader from "utils/UseFullPageLoader";
import useSearchParams from "utils/useSearchParams";
const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
});
function UpdateAuthor() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [authorQueryParams, setAuthorQueryParams] = useSearchParams();
  const currentPage = authorQueryParams.currentPage;
  const fromDate = authorQueryParams.fromDate;
  const toDate = authorQueryParams.toDate;
  const name = authorQueryParams.name;
  const jpName = authorQueryParams.jpName;
  const is_active = authorQueryParams.is_active;
  const redirect = authorQueryParams.redirect == null || undefined ? 2 : authorQueryParams.redirect;
  const [author] = useState(state.row);
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const { id } = params;

  const handleSearchParams = () => {
    const params = new URLSearchParams();

    // Required/default parameters
    if (id) params.set('id', id);
    if (currentPage) params.set('page', currentPage);

    // Optional parameters
    if (name) params.set('name', name);
    if (fromDate) params.set('from_date', fromDate);
    if (toDate) params.set('to_date', toDate);
    if (jpName) params.set('jp_name', jpName);

    // is_active logic
    if (is_active !== undefined) {
      let value = 'false';
      if (is_active === 'true') value = 'true';
      else if (is_active === 'none') value = 'none';
      params.set('is_active', value);
    }

    return `/admin/author/author-list?${params.toString()}`;
  };


  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: author?.name,
        jp_name: author.jp_name,
        jp_wikipedia: author.jp_wikipedia,
        is_active: author?.is_active ?? "",
      }}
      validationSchema={validationSchema}

      onSubmit={async (values, { resetForm, setSubmitting }) => {
        setLoading(true);
        showLoader()
        const updateData = {
          name: values.name,
          jp_name: values.jp_name,
          jp_wikipedia: values.jp_wikipedia,
          is_active: values.is_active,

        };
        const result = await updateAuthor(id, updateData);
        if (result?.isSuccess) {
          toast.success(`${result.message}`);
          setLoading(false);
          hideLoader()
          resetForm();
          const url = handleSearchParams()
          navigate(url);
        } else {
          setSubmitting(false);
          setLoading(false);
          hideLoader()
          return toast.error(
            result.message || `Something went wrong, please try again letter!`
          );
        }
      }}>
      {({
        handleChange,
        handleSubmit,
        values,
        errors,
        touched,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <>
            <Header />

            <Container className="mt--7" fluid>
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col lg="6">
                          <h1 className="mb-0">Update Author</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <Button
                            color="primary"
                            className=""
                            onClick={() => {
                              const isSameAuthorViewPage = localStorage.getItem('is_same_author_view_page');

                              if (isSameAuthorViewPage == 'true') {
                                navigate(-1)
                              }

                              if (redirect == 1) {
                                navigate(-1);
                              }

                              if (redirect == 2) {
                                const url = handleSearchParams()
                                navigate(url);
                              }
                            }}>
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                      </Row>

                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label required">
                              EN Name
                            </label>
                            <Input
                              className={clsx("form-control", {
                                "is-invalid":
                                  Boolean(errors.name) && touched.name,
                              })}
                              id="name"
                              name="name"
                              placeholder="Name"
                              type="text"
                              value={values.name}
                              onChange={handleChange}
                            />
                            <div className="text-danger text-align-top-center mt-1">
                              <ErrorMessage name="name" />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">JP Name</label>
                            <Input
                              className="form-control"
                              id="jp_name"
                              name="jp_name"
                              placeholder="JP Name"
                              type="text"
                              value={values.jp_name === null ? '' : values.jp_name}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">JP Wikipedia</label>
                            <Input
                              className="form-control"
                              id="jp_wikipedia"
                              name="jp_wikipedia"
                              placeholder="JP Wikipedia"
                              type="text"
                              value={values.jp_wikipedia === null ? '' : values.jp_wikipedia}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                      </Row>

                      <Row>
                        <Col lg="3">
                          <Button
                            type="submit"
                            className="my-3 w-100"
                            color="primary">
                            {loading && (
                              <span
                                className="indicator-progress"
                                style={{ display: "block" }}>
                                Please Wait..
                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                              </span>
                            )}
                            {!loading && (
                              <span className="indicator-label">
                                Update Author
                              </span>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Container>
            {loader}
          </>
        </form>
      )}
    </Formik>
  );
}

export default (props) => (
  <ProtectedRoute requiredPermissions="update-author">
    <UpdateAuthor {...props} />
  </ProtectedRoute>
);
